// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Reader_Class = require("../Control.Monad.Reader.Class/index.js");
var Data_Lens_Iso_Newtype = require("../Data.Lens.Iso.Newtype/index.js");
var Data_Lens_Record = require("../Data.Lens.Record/index.js");
var Data_Lens_Setter = require("../Data.Lens.Setter/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Profunctor_Strong = require("../Data.Profunctor.Strong/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Config = function (x) {
    return x;
};
var newtypeConfig = new Data_Newtype.Newtype(function (n) {
    return n;
}, Config);
var shouldCancelOnBlur = function (dictMonad) {
    return function (dictMonadAsk) {
        return Control_Bind.bind(dictMonad.Bind1())(Control_Monad_Reader_Class.asks(dictMonadAsk)(Data_Newtype.unwrap(newtypeConfig)))(function (v) {
            if (v.devOptions instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(dictMonad.Applicative0())(v.devOptions.value0.cancelInputsOnBlur);
            };
            if (v.devOptions instanceof Data_Maybe.Nothing) {
                return Control_Applicative.pure(dictMonad.Applicative0())(true);
            };
            throw new Error("Failed pattern match at Lunarbox.Config (line 48, column 3 - line 50, column 25): " + [ v.devOptions.constructor.name ]);
        });
    };
};
var _user = function (dictStrong) {
    var $20 = Data_Lens_Iso_Newtype["_Newtype"](newtypeConfig)(newtypeConfig)(dictStrong.Profunctor0());
    var $21 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "user";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($22) {
        return $20($21($22));
    };
};
var _userBus = function (dictStrong) {
    var $23 = _user(dictStrong);
    var $24 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "userBus";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($25) {
        return $23($24($25));
    };
};
var _pushStateInterface = function (dictStrong) {
    var $26 = Data_Lens_Iso_Newtype["_Newtype"](newtypeConfig)(newtypeConfig)(dictStrong.Profunctor0());
    var $27 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "pushStateInterface";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($28) {
        return $26($27($28));
    };
};
var _locationState = function (dictStrong) {
    var $29 = _pushStateInterface(dictStrong);
    var $30 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "locationState";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($31) {
        return $29($30($31));
    };
};
var _currentUser = function (dictStrong) {
    var $32 = _user(dictStrong);
    var $33 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "currentUser";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($34) {
        return $32($33($34));
    };
};
var _changeRoute = function (dictStrong) {
    var $35 = _pushStateInterface(dictStrong);
    var $36 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "pushState";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($37) {
        return $35($36($37));
    };
};
var _baseUrl = function (dictStrong) {
    var $38 = Data_Lens_Iso_Newtype["_Newtype"](newtypeConfig)(newtypeConfig)(dictStrong.Profunctor0());
    var $39 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "baseUrl";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($40) {
        return $38($39($40));
    };
};
var withBaseUrl = function (dictMonadReader) {
    var $41 = Control_Monad_Reader_Class.local(dictMonadReader);
    var $42 = Data_Lens_Setter.set(_baseUrl(Data_Profunctor_Strong.strongFn));
    return function ($43) {
        return $41($42($43));
    };
};
var _allowedNodes = function (dictStrong) {
    var $44 = Data_Lens_Iso_Newtype["_Newtype"](newtypeConfig)(newtypeConfig)(dictStrong.Profunctor0());
    var $45 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "allowedNodes";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($46) {
        return $44($45($46));
    };
};
module.exports = {
    Config: Config,
    shouldCancelOnBlur: shouldCancelOnBlur,
    withBaseUrl: withBaseUrl,
    "_user": _user,
    "_currentUser": _currentUser,
    "_userBus": _userBus,
    "_baseUrl": _baseUrl,
    "_allowedNodes": _allowedNodes,
    "_pushStateInterface": _pushStateInterface,
    "_changeRoute": _changeRoute,
    "_locationState": _locationState,
    newtypeConfig: newtypeConfig
};
